import React, { useState } from 'react';

const DemoCredentials = () => {
  const [isVisible, setIsVisible] = useState(false);

  const credentials = [
    {
      email: 'demo@pocuscloud.com',
      password: 'PocusDemo2025!',
      role: 'Demo User'
    },
    {
      email: 'test@pocuscloud.com',
      password: 'TestUser2025!',
      role: 'Test User'
    },
    {
      email: 'admin@pocuscloud.com',
      password: 'AdminUser2025!',
      role: 'Admin User'
    }
  ];

  const styles = {
    container: {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 1000
    },
    toggleButton: {
      backgroundColor: '#4285f4',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '56px',
      height: '56px',
      cursor: 'pointer',
      boxShadow: '0 4px 12px rgba(66, 133, 244, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '18px',
      transition: 'all 0.2s'
    },
    panel: {
      position: 'absolute',
      bottom: '70px',
      right: '0',
      backgroundColor: 'rgba(36, 36, 36, 0.95)',
      backdropFilter: 'blur(20px)',
      borderRadius: '12px',
      padding: '20px',
      minWidth: '300px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
      border: '1px solid #444',
      transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(10px) scale(0.95)',
      opacity: isVisible ? 1 : 0,
      visibility: isVisible ? 'visible' : 'hidden',
      transition: 'all 0.2s ease-out'
    },
    title: {
      color: '#ffffff',
      fontSize: '16px',
      fontWeight: 'bold',
      marginBottom: '16px',
      textAlign: 'center'
    },
    credentialItem: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '8px',
      padding: '12px',
      marginBottom: '12px',
      border: '1px solid rgba(255, 255, 255, 0.1)'
    },
    role: {
      color: '#4285f4',
      fontSize: '14px',
      fontWeight: '500',
      marginBottom: '8px'
    },
    credentialRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '4px'
    },
    label: {
      color: '#aaa',
      fontSize: '12px',
      minWidth: '60px'
    },
    value: {
      color: '#ffffff',
      fontSize: '12px',
      fontFamily: 'monospace',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      padding: '2px 6px',
      borderRadius: '4px',
      cursor: 'pointer',
      transition: 'background-color 0.2s'
    },
    note: {
      color: '#888',
      fontSize: '11px',
      textAlign: 'center',
      marginTop: '12px',
      fontStyle: 'italic'
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      // Could add a toast notification here
    });
  };

  return (
    <div style={styles.container}>
      {isVisible && (
        <div style={styles.panel}>
          <div style={styles.title}>Demo Credentials</div>
          {credentials.map((cred, index) => (
            <div key={index} style={styles.credentialItem}>
              <div style={styles.role}>{cred.role}</div>
              <div style={styles.credentialRow}>
                <span style={styles.label}>Email:</span>
                <span 
                  style={styles.value}
                  onClick={() => copyToClipboard(cred.email)}
                  title="Click to copy"
                >
                  {cred.email}
                </span>
              </div>
              <div style={styles.credentialRow}>
                <span style={styles.label}>Password:</span>
                <span 
                  style={styles.value}
                  onClick={() => copyToClipboard(cred.password)}
                  title="Click to copy"
                >
                  {cred.password}
                </span>
              </div>
            </div>
          ))}
          <div style={styles.note}>
            Click credentials to copy • For demo purposes only
          </div>
        </div>
      )}
      
      <button
        style={{
          ...styles.toggleButton,
          backgroundColor: isVisible ? '#666' : '#4285f4'
        }}
        onClick={() => setIsVisible(!isVisible)}
        title="Demo Credentials"
      >
        🔑
      </button>
    </div>
  );
};

export default DemoCredentials;
